import { render, staticRenderFns } from "./related-prompts-distribution-chart.component.vue?vue&type=template&id=256f1ead&scoped=true"
import script from "./related-prompts-distribution-chart.component.vue?vue&type=script&lang=ts"
export * from "./related-prompts-distribution-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-distribution-chart.component.vue?vue&type=style&index=0&id=256f1ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f1ead",
  null
  
)

export default component.exports